export default __webpack_public_path__ + "static/media/30.b25e8d21.png";